// removed by extract-text-webpack-plugin
module.exports = {"mainContainer":"KEmARsoia2fDb6wtH02Co","myMessage":"_0HUXB5V5go2Gc0oPzbr1","myMessageDarkTheme":"vu7qvTkLwiGEvVB-yPqTR","otherMessage":"_8ScoGfvNuZflGy4JB0Ukx","bounceIn":"_2QDkcaoHaN2mLs-Q2HvhRJ","otherMessageDarkTheme":"aYqwC4_MyKGFxgzcI5DTY"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/chat/chat-messages/message-history/message-card/MessageCard.css
// module id = 284
// module chunks = 0